// Desc: Create a slice for subscription plan
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  pricingTableLoaded,
  pricingTableLoading,
  pricingTableLoadingError,
} from "./subscriptionStateActions";
import { SubscriptionPlan } from "../../../types/models";
import {
  IActiveSubscriptionModel,
  IIntervalGroupModel,
  IPriceInfoModel,
} from "../../../types/types";
import { PURGE } from "redux-persist";

export interface SubscriptionPlanState {
  loading: boolean;
  error: string | null;
  data: IIntervalGroupModel[];
}

const initialState: SubscriptionPlanState = {
  loading: false,
  error: null,
  data: [],
};

const subscriptionPlanSlice = createSlice({
  name: "subscriptionPlan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
    builder.addCase(pricingTableLoading, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(pricingTableLoaded, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(pricingTableLoadingError, (state, action) => {
      state.loading = false;
      state.error = "Failed to fetch pricing data";
    });
  },
});

export default subscriptionPlanSlice.reducer;
